export const MAIN_URL = process.env.ENTRY || '/';
export const API_BASE_URL = `${MAIN_URL}api/`;



// WEBPACK FOOTER //
// ./src/config/consts/index.js